module.exports = __webpack_public_path__ + "static/media/step3-sell.cae41495.svg";